module.exports = __webpack_public_path__ + "static/media/dealer.5558f4a8.png";